import { useMutation } from '@tanstack/react-query';
import { postAdminPanelLogin } from '../services/admins';

const ADMIN_ACCESS_DENIED_MESSAGE =
  'Access denied. This account is not authorized for the admin panel.';

/** POST /admin/login — verify admin session after Firebase auth. */
export const useVerifyAdminSessionMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async () => {
      const result = await postAdminPanelLogin();
      if (!result.success || !result.data?.isAdmin) {
        const error = new Error(result.message || ADMIN_ACCESS_DENIED_MESSAGE);
        error.panelResult = result;
        throw error;
      }
      return result.data;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
